export default __webpack_public_path__ + "static/media/event4.e02bc945.png";